import React, { useEffect } from "react";
import { FaMapMarkedAlt, FaList, FaInfoCircle, FaTimes } from "react-icons/fa";
import Modal from "../../../../../components/modal";

const FeaturePedagogyModal = ({ isOpen, onGoToRoadmap, onAddToBacklog }) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter" && isOpen) {
        onGoToRoadmap();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onGoToRoadmap]);

  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} onClose={onGoToRoadmap} className="w-full md:w-[700px]">
      {/* Header */}
      <div className="p-6 border-b border-gray-200 bg-white rounded-t-lg">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-blue-500 rounded-lg flex items-center justify-center">
              <FaInfoCircle className="w-4 h-4 text-white" />
            </div>
            <h3 className="text-xl font-medium text-gray-900">
              La tâche a été catégorisée comme une <span className="font-bold text-blue-600">feature</span>
            </h3>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="p-6">
        <div className="mb-4">
          <p className="text-base text-gray-600 mb-3">Le ticket va donc être automatiquement déplacé vers la roadmap</p>
        </div>

        <div className="mb-6">
          <div className="bg-blue-50 border border-blue-200 rounded-md p-4">
            <h4 className="text-base font-medium text-blue-900 mb-2">Pourquoi ?</h4>
            <ul className="text-base text-blue-800 space-y-1">
              <li>• Budgétisation : Contrôler les coûts par rapport au devis initial</li>
              <li>• Priorisation : Organiser le développement selon les priorités business et les coûts</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="p-6 bg-gray-50 border-t border-gray-200 rounded-b-lg">
        <div className="flex gap-3">
          <button
            onClick={onAddToBacklog}
            className="flex-1 bg-white text-gray-700 py-2.5 px-4 rounded-md text-base font-medium border border-gray-300 hover:bg-gray-50 transition-colors duration-150 flex items-center justify-center gap-2">
            <FaList className="w-4 h-4" />
            Forcer le ticket dans le backlog
          </button>
          <button
            onClick={onGoToRoadmap}
            className="flex-1 bg-blue-600 text-white py-2.5 px-4 rounded-md text-base font-medium hover:bg-blue-700 transition-colors duration-150 flex items-center justify-center gap-2">
            <FaMapMarkedAlt className="w-4 h-4" />
            Accepter et aller à la roadmap
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default FeaturePedagogyModal;
